import { FilePathFormikField } from 'components/Wizards/FilePathFormikField/FilePathFormikField'
import { Field as BaseField } from 'components/Wizards/MobileWizards/Field/Field'

type Props = {
  label?: string
  fileInputPlaceholder?: string
  isLoading?: boolean
}

export const FilePathField = ({ label, fileInputPlaceholder, isLoading }: Props) => {
  return (
    <BaseField label={label || 'Name your content and select location'}>
      <FilePathFormikField
        placeholder={fileInputPlaceholder || 'Name your post...'}
        inputVariant="grey"
        locationPickerVariant="tertiary"
        locationPickerFullWidth
        isNameLoading={isLoading}
      />
    </BaseField>
  )
}
